// actionCenterService.js - API client for the Action Center.
// Matches the existing service pattern: REACT_APP_API_URL base, bearer token
// from localStorage.

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_URL}/api/action-center`;

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  };
}

export async function fetchSummary(domain) {
  const res = await axios.get(`${BASE}/summary`, {
    headers: authHeaders(),
    params: domain ? { domain } : {}
  });
  return res.data.summary;
}

export async function fetchActions(filters = {}) {
  const res = await axios.get(`${BASE}/`, { headers: authHeaders(), params: filters });
  return res.data;
}

export async function generateFromScan(scanId) {
  const res = await axios.post(`${BASE}/generate`, { scanId }, { headers: authHeaders() });
  return res.data;
}

export async function updateAction(id, status, note) {
  const res = await axios.patch(`${BASE}/${id}`, { status, note }, { headers: authHeaders() });
  return res.data;
}

export async function bulkUpdate(ids, status, note) {
  const res = await axios.post(`${BASE}/bulk`, { ids, status, note }, { headers: authHeaders() });
  return res.data;
}

export async function exportPlan({ ids, domain, format = 'csv', note } = {}) {
  const res = await axios.post(`${BASE}/export`, { ids, domain, format, note }, { headers: authHeaders() });
  return res.data;
}

export async function fetchBatches(domain) {
  const res = await axios.get(`${BASE}/batches`, {
    headers: authHeaders(),
    params: domain ? { domain } : {}
  });
  return res.data.batches;
}

// Turn an export response into a file the browser saves.
export function saveAsFile(filename, mime, body) {
  const blob = new Blob([body], { type: mime || 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'action-plan.txt';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// The user's saved audits, for the scan picker.
export async function fetchScans() {
  const res = await axios.get(`${BASE}/scans`, { headers: authHeaders() });
  return res.data.scans || [];
}
